// Extracts requestable WMS layers (those with a direct-child <Name>) from a GetCapabilities
// document. Hand-rolled (no DOMParser) so it runs identically in Node tests and the browser:
// namespace-agnostic (strips tag prefixes), skips comments/PIs, treats CDATA as text, decodes the
// standard XML entities. A <Name>/<Title> counts only when its immediate parent is a <Layer>, so a
// <Style><Name> never leaks in. Returns [{ name, title }]; title falls back to name.

var XML_ENTITIES = { amp: "&", lt: "<", gt: ">", quot: '"', apos: "'" };

function decodeXml(value) {
	return value.replace(/&(#x?[0-9a-fA-F]+|[a-zA-Z]+);/g, function (whole, body) {
		if (body.charAt(0) === "#") {
			var code = body.charAt(1) === "x" || body.charAt(1) === "X"
				? parseInt(body.slice(2), 16)
				: parseInt(body.slice(1), 10);
			return isNaN(code) ? whole : String.fromCharCode(code);
		}
		return Object.prototype.hasOwnProperty.call(XML_ENTITIES, body) ? XML_ENTITIES[body] : whole;
	});
}

export function parseWmsCapabilities(xml) {
	if (typeof xml !== "string" || xml === "") {
		return [];
	}
	var layers = [];
	var elementStack = []; // local names of open elements
	var layerStack = []; // { name, title } per open <Layer>
	var capture = null; // { layer, field } while reading a layer's <Name>/<Title> text

	var token = /<!\[CDATA\[([\s\S]*?)\]\]>|<!--[\s\S]*?-->|<\?[\s\S]*?\?>|<(\/)?\s*([A-Za-z0-9_.:-]+)([^>]*?)(\/)?>|([^<]+)/g;
	var match;
	while ((match = token.exec(xml)) !== null) {
		if (match[1] !== undefined) {
			if (capture) {
				capture.layer[capture.field] += match[1];
			}
			continue;
		}
		if (match[3] !== undefined) {
			var isClose = match[2] === "/";
			var selfClose = match[5] === "/";
			var local = match[3].split(":").pop().toLowerCase();
			if (isClose) {
				if ((local === "name" || local === "title") && capture) {
					capture = null;
				}
				if (local === "layer" && layerStack.length > 0) {
					var done = layerStack.pop();
					var name = decodeXml(done.name).trim();
					if (name.length > 0) {
						var title = decodeXml(done.title).trim();
						layers.push({ name: name, title: title.length > 0 ? title : name });
					}
				}
				elementStack.pop();
			} else {
				var parent = elementStack.length > 0 ? elementStack[elementStack.length - 1] : null;
				if (local === "layer") {
					layerStack.push({ name: "", title: "" });
				} else if ((local === "name" || local === "title") && parent === "layer" && layerStack.length > 0) {
					capture = { layer: layerStack[layerStack.length - 1], field: local };
				}
				if (selfClose) {
					if (local === "layer") {
						layerStack.pop();
					}
					capture = null;
				} else {
					elementStack.push(local);
				}
			}
			continue;
		}
		if (match[6] !== undefined && capture) {
			capture.layer[capture.field] += match[6];
		}
	}
	return layers;
}
